import React from "react";
import "./spinner.css";

export function Spinner() {
  return (
    <div className="lds-spinner [&>div:after]:bg-black dark:[&>div:after]:bg-white">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
